import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { KeycloakService } from './services/keycloak.service';

/**
 * Attaches the bearer token. Recovering from a 401 is deliberately NOT done
 * here: ErrorInterceptor sits closer to the backend and already refreshes and
 * retries once. A second retry at this level meant three requests per failing
 * call and, when the refresh came back empty, a logout() — a full-page
 * redirect that turned a rejected token into an endless reload loop.
 */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private readonly keycloak: KeycloakService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Respect a pre-set Authorization header (e.g. messaging requests that attach
    // their own token / dev override) — don't overwrite it.
    if (request.headers.has('Authorization')) {
      return next.handle(request);
    }
    if (!this.keycloak.enabled) {
      const t = localStorage.getItem('token');
      if (t) {
        request = request.clone({ setHeaders: { Authorization: `Bearer ${t}` } });
      }
      return next.handle(request);
    }

    return from(this.keycloak.getToken()).pipe(
      switchMap((token: string) =>
        next.handle(
          token
            ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
            : request,
        ),
      ),
    );
  }
}
